import { render, staticRenderFns } from "./ThanksPage.vue?vue&type=template&id=cc0376a4&scoped=true&"
import script from "./ThanksPage.vue?vue&type=script&lang=js&"
export * from "./ThanksPage.vue?vue&type=script&lang=js&"
import style0 from "./ThanksPage.vue?vue&type=style&index=0&id=cc0376a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0376a4",
  null
  
)

export default component.exports